// extracted by mini-css-extract-plugin
export var formContainer = "_cm-0";
export var message = "_cm-1";